import { render, staticRenderFns } from "./TaxAdvisorSettings.vue?vue&type=template&id=1b435c08&"
import script from "./TaxAdvisorSettings.vue?vue&type=script&lang=js&"
export * from "./TaxAdvisorSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaxAdvisorSettings.vue"
export default component.exports